import { resolveUrl } from '../content/assets';
import '../builder.css';

export function renderBlock(b) {
  switch (b.type) {
    case 'heading': {
      const Level = b.level || 'h2';
      return (
        <Level
          className="pb-heading"
          style={{
            textAlign: b.align || 'left',
            color: b.color || undefined,
            fontSize: b.size || undefined,
            fontWeight: b.weight || undefined,
            backgroundColor: b.bg || undefined,
            padding: b.pad || undefined,
            borderRadius: b.radius || undefined,
          }}
        >
          {b.text}
        </Level>
      );
    }
    case 'text':
      return (
        <p className="pb-text" style={{ textAlign: b.align || 'left', color: b.color || undefined, fontSize: b.size || undefined }}>
          {b.text}
        </p>
      );
    case 'image': {
      const justify = b.align === 'center' ? 'center' : b.align === 'right' ? 'flex-end' : 'flex-start';
      return b.url ? (
        <div className="pb-image-wrap" style={{ display: 'flex', justifyContent: justify }}>
          <img
            className="pb-image"
            src={resolveUrl(b.url)}
            alt={b.alt || ''}
            style={{
              borderRadius: b.shape === 'circle' ? '50%' : (b.radius || undefined),
              objectFit: b.fit || (b.shape === 'circle' ? 'cover' : undefined),
              width: b.width || undefined,
              height: b.height || undefined,
            }}
          />
        </div>
      ) : null;
    }
    case 'button':
      return (
        <div className="pb-button-wrap" style={{ textAlign: b.align || 'left' }}>
          <a className="pb-button" href={b.link || '#'} style={{ backgroundColor: b.bg || undefined, color: b.color || undefined, fontSize: b.size || undefined }}>{b.text}</a>
        </div>
      );
    case 'video': {
      const justify = b.align === 'center' ? 'center' : b.align === 'right' ? 'flex-end' : 'flex-start';
      return b.url ? (
        <div className="pb-video-wrap" style={{ display: 'flex', justifyContent: justify }}>
          <video className="pb-video" controls src={resolveUrl(b.url)} />
        </div>
      ) : null;
    }
    case 'spacer':
      return <div style={{ height: (Number(b.height) || 20) + 'px' }} />;
    default:
      return null;
  }
}

function renderBlocks(blocks) {
  return (blocks || []).map((b) => <div className="pb-block" key={b.id}>{renderBlock(b)}</div>);
}

function renderColumn(c, gap) {
  return (
    <div
      className="pb-col"
      key={c.id}
      style={{
        width: `calc(${((c.span || 12) / 12) * 100}% - ${gap * (12 - (c.span || 12)) / 12}px)`,
        backgroundColor: c.bg || undefined,
        padding: c.pad || undefined,
        borderRadius: c.radius || undefined,
        boxShadow: c.shadow ? '6px 4px 4px rgba(0, 0, 0, 0.25)' : undefined,
        textAlign: c.align || undefined,
        color: c.color || undefined,
      }}
    >
      {renderBlocks(c.blocks)}
      {(c.rows || []).map((r) => renderRow(r))}
    </div>
  );
}

function renderRow(r) {
  const gap = r.gap || 20;
  const vAlign = r.valign === 'top' ? 'flex-start' : r.valign === 'middle' ? 'center' : r.valign === 'bottom' ? 'flex-end' : undefined;
  return (
    <div className="pb-row" key={r.id} style={{ gap: r.gap || undefined, alignItems: vAlign }}>
      {(r.columns || []).map((c) => renderColumn(c, gap))}
    </div>
  );
}

export default function PageRenderer({ sections }) {
  return (
    <div className="pb-page">
      {(sections || []).map((s) => (
        <section
          className="pb-section"
          id={s.id}
          key={s.id}
          style={{ backgroundColor: s.bg || undefined, color: s.color || undefined, padding: s.pad || undefined }}
        >
          {s.bgImage && (
            <div className="pb-section-bg" style={{ backgroundImage: `url(${resolveUrl(s.bgImage)})`, opacity: s.bgOpacity != null ? s.bgOpacity : 0.15 }} />
          )}
          <div className="pb-section-content">
            {(s.title || s.icon) && (
              <div className="pb-section-head">
                <span className="pb-line" />
                {s.icon && <img className="pb-section-icon" src={resolveUrl(s.icon)} alt={s.title || ''} />}
                <span className="pb-line" />
              </div>
            )}
            {s.title && <h2 className="pb-section-title" style={{ color: s.titleColor || undefined }}>{s.title}</h2>}
            <div className="pb-inner">
              {(s.rows || []).map((r) => renderRow(r))}
            </div>
          </div>
        </section>
      ))}
    </div>
  );
}
